/**
 * Fast heuristic that guesses whether a string is Markdown.
 * - Starts with a super-cheap character scan to avoid the heavier RegExp
 *   when the text clearly cannot be Markdown.
 * - Uses a single pre-compiled RegExp that covers the most common
 *   Markdown syntax elements (headers, lists, blockquotes, fences,
 *   bold/italic, links, images, tables, horizontal rules).
 */
const MD_QUICK_SCAN = /[#>*_`$begin:math:display$$end:math:display$!|~-]/; // any "special" Markdown char

const MD_PATTERN =
    /(?:^|\n)\s*(?:#{1,6}\s|>\s|[*\-+]\s|\d+\.\s|`{3,}|[-*_]{3,}\s*$|\|.*\|)|\*\*[^*\n]+\*\*|__[^_\n]+__|\*[^*\n]+\*|_[^_\n]+_|`[^`\n]+`|\[.+?\]\(.+?\)|!\[.*?\]\(.+?\)|\$begin:math:[^$]+\$.*?\$end:math:[^$]+\$/;

/**
 * Test if a string looks like Markdown.
 *
 * @param text - The string to test.
 * @returns True if the string looks like Markdown, false otherwise.
 */
export function looksLikeMarkdown(text: string): boolean {
    if (!text) return false;

    // Lightning-fast pre-filter: skips almost everything that's pure text
    if (!MD_QUICK_SCAN.test(text)) return false;

    // Heavier test only if the scan above found Markdown-ish chars
    return MD_PATTERN.test(text);
}
